import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

function ChatTabs({ sessions, onNewSession, onSelectSession, activeSessionId, stopAudio }) {
  const navigate = useNavigate();
  const [name, setName] = useState('');

  const handleCreate = async () => {
    if (!name.trim()) return;

    try {
      stopAudio();
    } catch (error) {

    }

    try {
      const res = await fetch(process.env.REACT_APP_API_BASE_URL + '/chat/session', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_name: name })
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || 'Terjadi kesalahan');
      }

      const session = await res.json();
      onNewSession(session);
      setName('');
    } catch (error) {
      Swal.fire('Oops!', error.message || 'Silakan coba lagi.', 'error');
    }

  };

  const handleDelete = async (id) => {

    stopAudio();

    const result = await Swal.fire({
      title: 'Hapus Sesi?',
      text: 'Sesi chat ini akan dihapus secara permanen.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ya, hapus!',
      cancelButtonText: 'Batal'
    });

    if (result.isConfirmed) {
      try {
        await fetch(`${process.env.REACT_APP_API_BASE_URL}/chat/session/${id}`, {
          method: 'DELETE',
          credentials: 'include'
        });

        Swal.fire('Terhapus!', 'Sesi berhasil dihapus.', 'success');
        window.location.reload();
      } catch (err) {
        Swal.fire('Oops!', (err.response?.data?.message || "Silakan coba lagi."), 'error');
      }
    }
  };

  return (
    <div>
      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control input"
          placeholder="Nama sesi baru"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <button className="btn btn-outline-secondary" onClick={handleCreate}>Buat</button>
      </div>

      <ul className="list-group">
        {sessions.map(sess => (
          <li
            key={sess.id}
            className={`list-group-item d-flex justify-content-between align-items-center list-group-item-action ${sess.id === activeSessionId ? 'active bg-white text-dark' : ''}`}
          >
            <span onClick={() => {
              stopAudio();
              navigate(`/dashboard/chat/${sess.id}`);
            }} style={{ flex: 1, cursor: 'pointer' }}>
              {sess.session_name}
            </span>
            <button
              className="btn btn-sm btn-secondary ms-2"
              onClick={() => handleDelete(sess.id)}
              title="Hapus sesi"
            >
              <i className='fa fa-trash'></i>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ChatTabs;
